import React, { useEffect } from "react";

const CookieYes = () => {

    useEffect(() => {
        const script = document.createElement('script');

        script.id = "cookieyes"
        script.type = "text/javascript"
        script.src = "https://cdn-cookieyes.com/client_data/53632c95c3007ca4b2d12f847433301c/script.js"

        document.head.appendChild(script);

    }, [])

    return (
        <></>
    )
}

export default CookieYes
